import React, { useState, useEffect } from "react";
import { StyleSheet, Text, View } from "react-native";
import { LinkContainer } from "react-router-bootstrap";
import LoaderButton from "./LoaderButton";
import FormTextInput from "./FormTextInput";
import FormGroup from "./FormGroup";
import { useNavigate } from "react-router-dom";
export type StateProps = {
  loading: boolean;
  isAuthenticated: boolean;
};
export type DispatchProps = {
  login: (arg0: string, arg1: string) => void;
};
export type OwnProps = {};
export type Props = StateProps & DispatchProps & OwnProps;
export default function Login(props: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const nav = useNavigate();
  const { isAuthenticated } = props;

  function validateForm() {
    return email.length > 0 && password.length > 0;
  }

  function onSubmit() {
    props.login(email, password);
  }

  useEffect(() => {
    if (isAuthenticated) {
      nav("/");
    }
  }, [isAuthenticated, nav]);
  return (
    <View style={styles.container}>
      <FormGroup>
        <Text>Email</Text>
        <FormTextInput
          autoFocus
          autoCapitalize="none"
          type="email"
          value={email}
          onChangeText={setEmail}
        />
      </FormGroup>
      <FormGroup>
        <Text>Password</Text>
        <FormTextInput
          secureTextEntry={true}
          value={password}
          onChangeText={setPassword}
          type="password"
        />
      </FormGroup>
      <FormGroup>
        <LoaderButton
          disabled={!validateForm()}
          label="Login"
          onPress={onSubmit}
          loading={props.loading}
        />
      </FormGroup>
      <FormGroup>
        <LinkContainer
          style={{
            marginTop: 30,
            width: "100%",
            textAlign: "center",
            fontWeight: "bold",
          }}
          to="/signup"
        >
          <div>Signup Instead</div>
        </LinkContainer>
      </FormGroup>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "stretch",
    alignSelf: "center",
    maxWidth: 400,
    width: "100%",
  },
});
